export default __webpack_public_path__ + "35faff795d74b3db62f1864a34c7c6ab.png";